<template>
  <div class="order_nav">
    <div class="order_logo">
      <div class="logo_head">
        <img v-if="userInfo" :src="userInfo.avatar" alt="" />
      </div>
      <div class="logo_in">已登录</div>
    </div>
    <ul class="order_menu">
      <li :class="menuType == 1 ? 'on' : ''" @click="goMenuHandle({path:'/mine/order'})">我的订单</li>
      <li :class="menuType == 2 ? 'on' : ''" @click="goMenuHandle({path:'/mine/integral'})">我的积分</li>
      <li :class="menuType == 3 ? 'on' : ''" @click="goMenuHandle({path:'/mine/collection'})">我的收藏</li>
      <li :class="menuType == 4 ? 'on' : ''" @click="goMenuHandle({path:'/mine/receiving'})">地址管理</li>
      <li @click.stop="goBackHandle(100)">退出登录</li>
    </ul>
  </div>
</template>
<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  props: {
    menuType: {
      type: Number,
      value: 1
    }
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const userInfo = store.state.userInfo
    const goBackHandle = (menu) => {
      if (menu === 100) {
        localStorage.removeItem('userInfo')
        store.state.userInfo = null
        router.push({ path: '/login' })
      }
    }
    const goMenuHandle = (obj) => {
      router.push(obj)
    }
    return {
      goBackHandle,
      userInfo,
      goMenuHandle
    }
  }
}
</script>
<style lang="scss" scoped>
.order_nav {
  width: 290px;
  background: white;
  height: 630px;
  .order_logo {
    height: 240px;
    border-bottom: 2px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .logo_in {
      font-size: 18px;
      font-weight: 400;
      line-height: 28px;
      color: #3e3a39;
    }
    .logo_head {
      width: 100px;
      height: 100px;
      background: #ffffff;
      border: 1px solid #707070;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 0 24px 0;
      img{
        width: 100%;
      }
    }
  }
}

.order_menu {
  margin: 36px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  li {
    font-size: 18px;
    font-weight: 400;
    margin: 0 0 24px 0;
    padding: 0 0 0 10px;
    color: #3e3a39;
    position: relative;
    cursor: pointer;
    &.on {
      padding: 0 0 0 10px;
      &:before {
        content: "";
        width: 6px;
        height: 6px;
        background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
        border-radius: 50%;
        position: absolute;
        top: 8px;
        left: -8px;
      }
    }
  }
}
</style>
